export const parseFileNameFromHeader = (disposition: string | null): string | null => {
  if (!disposition) {
    return null;
  } 
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^;"]+)/i.exec(disposition);
  return decodeURIComponent((match && (match[1] || match[2])) || '');
};
